package one.healthium.ui.compose.components

import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.StartOffset
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.Color
import com.valentinilk.shimmer.ShimmerBounds
import com.valentinilk.shimmer.defaultShimmerTheme
import com.valentinilk.shimmer.rememberShimmer
import com.valentinilk.shimmer.shimmer
import kotlin.time.Duration.Companion.seconds

data class AppShimmerConfig(
    val color: Color,
    val duration: Int,
    val interval: Int,
)

fun Modifier.appShimmer(
    config: AppShimmerConfig?
): Modifier = composed {
    if (config != null) {
        val shimmer = rememberShimmer(
            shimmerBounds = ShimmerBounds.View,
            theme = createCustomTheme(config),
        )
        shimmer(customShimmer = shimmer)
    } else {
        Modifier
    }
}

private fun createCustomTheme(config: AppShimmerConfig) = defaultShimmerTheme.copy(
    animationSpec = infiniteRepeatable(
        animation = tween(
            durationMillis = config.duration.seconds.inWholeMilliseconds.toInt(),
            delayMillis = config.interval.seconds.inWholeMilliseconds.toInt(),
            easing = LinearEasing,
        ),
        repeatMode = RepeatMode.Restart,
        initialStartOffset = StartOffset(-config.interval.seconds.inWholeMilliseconds.toInt())
    ),
    rotation = 0f,
    blendMode = BlendMode.SrcAtop,
    shaderColors = listOf(
        Color.Unspecified.copy(alpha = 0.01f),
        config.color.copy(alpha = 1f),
        Color.Unspecified.copy(alpha = 0.01f),
    ),
    shaderColorStops = null,
)